const utmTags = `<script>
    function checkQueryParam() {
        return new URLSearchParams(window.location.search).get("utm_source");
    }
    function getCookie() {
        const cookies = document.cookie.split(";").reduce((acc, cookie) => {
            var [key] = cookie.split("=");
            return acc[key] = cookie;
        }, {});
        return cookies["utm_source"];
    }
    function setLinkHref(link, params) {
        if (link.hasAttribute("href")) {
            var separator = new URL(link.href).search.length ? "&" : "?";
            link.href += separator + params;
        }
    }
    function getParams() {
        var isUtmParam = checkQueryParam();
        var cookieParam = getCookie();
        var searchParams = window.location.search.substring(1);
        return isUtmParam ? searchParams : cookieParam ? cookieParam + "&" + searchParams : searchParams;
    }
    window.onload = function() {
        var params = getParams();
        var linkList = document.querySelectorAll('[id^="utmTagLink"]');
        linkList.forEach(function (link) {
            setLinkHref(link, params);
        });
    };
</script>`;

module.exports = {
    utmTags
};
